<!--
 * @Author: yyl
 * @Date: 2025-06-26 08:55:40
 * @LastEditTime: 2025-07-01 16:35:15
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/home/CardGrid.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="card">
    <div class="card-title flex items-center content-space-between">
      <div class="card-title--left">{{ params.title }}</div>

      <div class="card-title--right" @click="handleGoListClick">更多></div>
    </div>

    <div
      style="justify-content: flex-start; flex-wrap: wrap; margin: 20px 0"
      class="flex"
    >
      <!-- <el-row>
        <el-col
          :xs="24"
          :sm="8"
          :md="6"
          :lg="4.5"
          v-for="item in params.articles"
          :key="item.id"
        > -->
      <div
        v-for="item in params.articles"
        :key="item.id"
        style="text-align: center; flex: 0 0 20%"
        @click="handleGoDetailClick(item)"
      >
        <div
          class="card-content"
          style="padding: 8px; font-size: 14px; width: 100%"
        >
          <el-image
            style="width: 200px; height: 200px; border-radius: 50%"
            :src="item.thumb_pic"
            fit="cover"
          ></el-image>
        </div>
        <div
          class="card-subtitle"
          style="
            padding-bottom: 4px;
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            color: #14468b;
          "
        >
          {{ item.title }}
        </div>
      </div>
      <!-- </el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
    },
  },

  data() {
    return {}
  },

  // watch: {
  //   params: {
  //     deep: true,
  //     immediate: true, // （可选）立即触发一次
  //     handler() {
  //       this.getData()
  //     },
  //   },
  // },

  mounted() {},

  methods: {
    // getData() {
    //   const articles = this.params.articles || []

    //   this.oneData = articles[0] || {}
    //   this.listData = articles.filter((item) => item.id != this.oneData.id)
    // },

    handleGoListClick() {
      this.$router.push(
        `/teachers?section_id=${this.params.section_id}&title=${this.params.title}`
      )
    },
    handleGoDetailClick(item) {
      this.$router.push(`/article?id=${item.id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  // height: 470px;
  color: #565656;
  font-size: 16px;
}

.card-title {
  padding: 0 4px;
  border-bottom: 3px solid #b4d13d;
}

.card-title--left {
  color: #42679f;
  font-size: 18px;
  font-weight: bold;
  padding: 14px 0;
}

.card-title--right {
  font-size: 14px;

  text-align: right;
  padding: 18px 0;
  cursor: pointer;
}

.card-image {
  display: block;
  width: 100%;
  height: 324px;
  // background-color: skyblue;
}

.card-content {
  font-size: 15px;
  padding: 10px 0;
  min-height: 42px;
  cursor: pointer;
  &:hover {
    color: #15458b;
    text-decoration: underline;
  }
}

.card-subtitle {
  font-size: 13px;
}
</style>
